module.exports = __webpack_public_path__ + "static/media/rocket.ceacf4e6.svg";